<script setup>
import { computed, ref, watch } from "vue";
import ArgonSelect from "@/components/ArgonSelect.vue";

const props = defineProps({
  id: {
    type: String,
    default: "phone-input",
  },
  modelValue: {
    type: String,
    default: "",
  },
  error: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  maxLength: {
    type: Number,
    default: 15,
  },
  countryOptions: {
    type: Array,
    default: () => [
      { code: "ES", dial_code: "+34", flag: "🇪🇸", label: "España" },
      { code: "AF", dial_code: "+93", flag: "🇦🇫", label: "Afganistán" },
      { code: "ZA", dial_code: "+27", flag: "🇿🇦", label: "Sudáfrica" },
      { code: "AL", dial_code: "+355", flag: "🇦🇱", label: "Albania" },
      { code: "DE", dial_code: "+49", flag: "🇩🇪", label: "Alemania" },
      { code: "AD", dial_code: "+376", flag: "🇦🇩", label: "Andorra" },
      { code: "AO", dial_code: "+244", flag: "🇦🇴", label: "Angola" },
      { code: "AG", dial_code: "+1", flag: "🇦🇬", label: "Antigua y Barbuda" },
      { code: "SA", dial_code: "+966", flag: "🇸🇦", label: "Arabia Saudita" },
      { code: "DZ", dial_code: "+213", flag: "🇩🇿", label: "Argelia" },
      { code: "IT", dial_code: "+39", flag: "🇮🇹", label: "Italia" },
      { code: "AR", dial_code: "+54", flag: "🇦🇷", label: "Argentina" },
      { code: "AM", dial_code: "+374", flag: "🇦🇲", label: "Armenia" },
      { code: "AU", dial_code: "+61", flag: "🇦🇺", label: "Australia" },
      { code: "AT", dial_code: "+43", flag: "🇦🇹", label: "Austria" },
      { code: "AZ", dial_code: "+994", flag: "🇦🇿", label: "Azerbaiyán" },
      { code: "BS", dial_code: "+1", flag: "🇧🇸", label: "Bahamas" },
      { code: "BH", dial_code: "+973", flag: "🇧🇭", label: "Baréin" },
      { code: "BD", dial_code: "+880", flag: "🇧🇩", label: "Bangladés" },
      { code: "BB", dial_code: "+1", flag: "🇧🇧", label: "Barbados" },
      { code: "BE", dial_code: "+32", flag: "🇧🇪", label: "Bélgica" },
      { code: "BZ", dial_code: "+501", flag: "🇧🇿", label: "Belice" },
      { code: "BJ", dial_code: "+229", flag: "🇧🇯", label: "Benín" },
      { code: "BY", dial_code: "+375", flag: "🇧🇾", label: "Bielorrusia" },
      { code: "BO", dial_code: "+591", flag: "🇧🇴", label: "Bolivia" },
      { code: "BA", dial_code: "+387", flag: "🇧🇦", label: "Bosnia y Herzegovina" },
      { code: "BW", dial_code: "+267", flag: "🇧🇼", label: "Botsuana" },
      { code: "BR", dial_code: "+55", flag: "🇧🇷", label: "Brasil" },
      { code: "BN", dial_code: "+673", flag: "🇧🇳", label: "Brunéi" },
      { code: "BG", dial_code: "+359", flag: "🇧🇬", label: "Bulgaria" },
      { code: "BF", dial_code: "+226", flag: "🇧🇫", label: "Burkina Faso" },
      { code: "BI", dial_code: "+257", flag: "🇧🇮", label: "Burundi" },
      { code: "BT", dial_code: "+975", flag: "🇧🇹", label: "Bután" },
      { code: "CV", dial_code: "+238", flag: "🇨🇻", label: "Cabo Verde" },
      { code: "KH", dial_code: "+855", flag: "🇰🇭", label: "Camboya" },
      { code: "CM", dial_code: "+237", flag: "🇨🇲", label: "Camerún" },
      { code: "CA", dial_code: "+1", flag: "🇨🇦", label: "Canadá" },
      { code: "QA", dial_code: "+974", flag: "🇶🇦", label: "Catar" },
      { code: "TD", dial_code: "+235", flag: "🇹🇩", label: "Chad" },
      { code: "CL", dial_code: "+56", flag: "🇨🇱", label: "Chile" },
      { code: "CN", dial_code: "+86", flag: "🇨🇳", label: "China" },
      { code: "CY", dial_code: "+357", flag: "🇨🇾", label: "Chipre" },
      { code: "VA", dial_code: "+39", flag: "🇻🇦", label: "Ciudad del Vaticano" },
      { code: "MX", dial_code: "+52", flag: "🇲🇽", label: "México" },
      { code: "CO", dial_code: "+57", flag: "🇨🇴", label: "Colombia" },
      { code: "KM", dial_code: "+269", flag: "🇰🇲", label: "Comoras" },
      { code: "KP", dial_code: "+850", flag: "🇰🇵", label: "Corea del Norte" },
      { code: "KR", dial_code: "+82", flag: "🇰🇷", label: "Corea del Sur" },
      { code: "CI", dial_code: "+225", flag: "🇨🇮", label: "Costa de Marfil" },
      { code: "CR", dial_code: "+506", flag: "🇨🇷", label: "Costa Rica" },
      { code: "HR", dial_code: "+385", flag: "🇭🇷", label: "Croacia" },
      { code: "CU", dial_code: "+53", flag: "🇨🇺", label: "Cuba" },
      { code: "DK", dial_code: "+45", flag: "🇩🇰", label: "Dinamarca" },
      { code: "DM", dial_code: "+1", flag: "🇩🇲", label: "Dominica" },
      { code: "EC", dial_code: "+593", flag: "🇪🇨", label: "Ecuador" },
      { code: "EG", dial_code: "+20", flag: "🇪🇬", label: "Egipto" },
      { code: "SV", dial_code: "+503", flag: "🇸🇻", label: "El Salvador" },
      { code: "AE", dial_code: "+971", flag: "🇦🇪", label: "Emiratos Árabes Unidos" },
      { code: "ER", dial_code: "+291", flag: "🇪🇷", label: "Eritrea" },
      { code: "SK", dial_code: "+421", flag: "🇸🇰", label: "Eslovaquia" },
      { code: "SI", dial_code: "+386", flag: "🇸🇮", label: "Eslovenia" },
      { code: "US", dial_code: "+1", flag: "🇺🇸", label: "Estados Unidos" },
      { code: "EE", dial_code: "+372", flag: "🇪🇪", label: "Estonia" },
      { code: "SZ", dial_code: "+268", flag: "🇸🇿", label: "Esuatini" },
      { code: "ET", dial_code: "+251", flag: "🇪🇹", label: "Etiopía" },
      { code: "PH", dial_code: "+63", flag: "🇵🇭", label: "Filipinas" },
      { code: "FI", dial_code: "+358", flag: "🇫🇮", label: "Finlandia" },
      { code: "FJ", dial_code: "+679", flag: "🇫🇯", label: "Fiyi" },
      { code: "FR", dial_code: "+33", flag: "🇫🇷", label: "Francia" },
      { code: "GA", dial_code: "+241", flag: "🇬🇦", label: "Gabón" },
      { code: "GM", dial_code: "+220", flag: "🇬🇲", label: "Gambia" },
      { code: "GE", dial_code: "+995", flag: "🇬🇪", label: "Georgia" },
      { code: "GH", dial_code: "+233", flag: "🇬🇭", label: "Ghana" },
      { code: "GD", dial_code: "+1", flag: "🇬🇩", label: "Granada" },
      { code: "GR", dial_code: "+30", flag: "🇬🇷", label: "Grecia" },
      { code: "GT", dial_code: "+502", flag: "🇬🇹", label: "Guatemala" },
      { code: "GN", dial_code: "+224", flag: "🇬🇳", label: "Guinea" },
      { code: "GQ", dial_code: "+240", flag: "🇬🇶", label: "Guinea Ecuatorial" },
      { code: "GW", dial_code: "+245", flag: "🇬🇼", label: "Guinea-Bisáu" },
      { code: "GY", dial_code: "+592", flag: "🇬🇾", label: "Guyana" },
      { code: "HT", dial_code: "+509", flag: "🇭🇹", label: "Haití" },
      { code: "HN", dial_code: "+504", flag: "🇭🇳", label: "Honduras" },
      { code: "HU", dial_code: "+36", flag: "🇭🇺", label: "Hungría" },
      { code: "IN", dial_code: "+91", flag: "🇮🇳", label: "India" },
      { code: "ID", dial_code: "+62", flag: "🇮🇩", label: "Indonesia" },
      { code: "IQ", dial_code: "+964", flag: "🇮🇶", label: "Irak" },
      { code: "IR", dial_code: "+98", flag: "🇮🇷", label: "Irán" },
      { code: "IE", dial_code: "+353", flag: "🇮🇪", label: "Irlanda" },
      { code: "IS", dial_code: "+354", flag: "🇮🇸", label: "Islandia" },
      { code: "MH", dial_code: "+692", flag: "🇲🇭", label: "Islas Marshall" },
      { code: "SB", dial_code: "+677", flag: "🇸🇧", label: "Islas Salomón" },
      { code: "IL", dial_code: "+972", flag: "🇮🇱", label: "Israel" },
      { code: "JM", dial_code: "+1", flag: "🇯🇲", label: "Jamaica" },
      { code: "JP", dial_code: "+81", flag: "🇯🇵", label: "Japón" },
      { code: "JO", dial_code: "+962", flag: "🇯🇴", label: "Jordania" },
      { code: "KZ", dial_code: "+7", flag: "🇰🇿", label: "Kazajistán" },
      { code: "KE", dial_code: "+254", flag: "🇰🇪", label: "Kenia" },
      { code: "KG", dial_code: "+996", flag: "🇰🇬", label: "Kirguistán" },
      { code: "KI", dial_code: "+686", flag: "🇰🇮", label: "Kiribati" },
      { code: "KW", dial_code: "+965", flag: "🇰🇼", label: "Kuwait" },
      { code: "LA", dial_code: "+856", flag: "🇱🇦", label: "Laos" },
      { code: "LS", dial_code: "+266", flag: "🇱🇸", label: "Lesoto" },
      { code: "LV", dial_code: "+371", flag: "🇱🇻", label: "Letonia" },
      { code: "LB", dial_code: "+961", flag: "🇱🇧", label: "Líbano" },
      { code: "LR", dial_code: "+231", flag: "🇱🇷", label: "Liberia" },
      { code: "LY", dial_code: "+218", flag: "🇱🇾", label: "Libia" },
      { code: "LI", dial_code: "+423", flag: "🇱🇮", label: "Liechtenstein" },
      { code: "LT", dial_code: "+370", flag: "🇱🇹", label: "Lituania" },
      { code: "LU", dial_code: "+352", flag: "🇱🇺", label: "Luxemburgo" },
      { code: "MK", dial_code: "+389", flag: "🇲🇰", label: "Macedonia del Norte" },
      { code: "MG", dial_code: "+261", flag: "🇲🇬", label: "Madagascar" },
      { code: "MY", dial_code: "+60", flag: "🇲🇾", label: "Malasia" },
      { code: "MW", dial_code: "+265", flag: "🇲🇼", label: "Malaui" },
      { code: "MV", dial_code: "+960", flag: "🇲🇻", label: "Maldivas" },
      { code: "ML", dial_code: "+223", flag: "🇲🇱", label: "Malí" },
      { code: "MT", dial_code: "+356", flag: "🇲🇹", label: "Malta" },
      { code: "MA", dial_code: "+212", flag: "🇲🇦", label: "Marruecos" },
      { code: "MU", dial_code: "+230", flag: "🇲🇺", label: "Mauricio" },
      { code: "MR", dial_code: "+222", flag: "🇲🇷", label: "Mauritania" },
      { code: "FM", dial_code: "+691", flag: "🇫🇲", label: "Micronesia" },
      { code: "MD", dial_code: "+373", flag: "🇲🇩", label: "Moldavia" },
      { code: "MC", dial_code: "+377", flag: "🇲🇨", label: "Mónaco" },
      { code: "MN", dial_code: "+976", flag: "🇲🇳", label: "Mongolia" },
      { code: "ME", dial_code: "+382", flag: "🇲🇪", label: "Montenegro" },
      { code: "MZ", dial_code: "+258", flag: "🇲🇿", label: "Mozambique" },
      { code: "MM", dial_code: "+95", flag: "🇲🇲", label: "Myanmar" },
      { code: "NA", dial_code: "+264", flag: "🇳🇦", label: "Namibia" },
      { code: "NR", dial_code: "+674", flag: "🇳🇷", label: "Nauru" },
      { code: "NP", dial_code: "+977", flag: "🇳🇵", label: "Nepal" },
      { code: "NI", dial_code: "+505", flag: "🇳🇮", label: "Nicaragua" },
      { code: "NE", dial_code: "+227", flag: "🇳🇪", label: "Níger" },
      { code: "NG", dial_code: "+234", flag: "🇳🇬", label: "Nigeria" },
      { code: "NO", dial_code: "+47", flag: "🇳🇴", label: "Noruega" },
      { code: "NZ", dial_code: "+64", flag: "🇳🇿", label: "Nueva Zelanda" },
      { code: "OM", dial_code: "+968", flag: "🇴🇲", label: "Omán" },
      { code: "NL", dial_code: "+31", flag: "🇳🇱", label: "Países Bajos" },
      { code: "PK", dial_code: "+92", flag: "🇵🇰", label: "Pakistán" },
      { code: "PW", dial_code: "+680", flag: "🇵🇼", label: "Palaos" },
      { code: "PS", dial_code: "+970", flag: "🇵🇸", label: "Palestina" },
      { code: "PA", dial_code: "+507", flag: "🇵🇦", label: "Panamá" },
      { code: "PG", dial_code: "+675", flag: "🇵🇬", label: "Papúa Nueva Guinea" },
      { code: "PY", dial_code: "+595", flag: "🇵🇾", label: "Paraguay" },
      { code: "PE", dial_code: "+51", flag: "🇵🇪", label: "Perú" },
      { code: "PL", dial_code: "+48", flag: "🇵🇱", label: "Polonia" },
      { code: "PT", dial_code: "+351", flag: "🇵🇹", label: "Portugal" },
      { code: "GB", dial_code: "+44", flag: "🇬🇧", label: "Reino Unido" },
      { code: "CF", dial_code: "+236", flag: "🇨🇫", label: "República Centroafricana" },
      { code: "CG", dial_code: "+242", flag: "🇨🇬", label: "República del Congo" },
      { code: "CD", dial_code: "+243", flag: "🇨🇩", label: "República Democrática del Congo" },
      { code: "DO", dial_code: "+1", flag: "🇩🇴", label: "República Dominicana" },
      { code: "CZ", dial_code: "+420", flag: "🇨🇿", label: "República Checa" },
      { code: "RO", dial_code: "+40", flag: "🇷🇴", label: "Rumanía" },
      { code: "RW", dial_code: "+250", flag: "🇷🇼", label: "Ruanda" },
      { code: "RU", dial_code: "+7", flag: "🇷🇺", label: "Rusia" },
      { code: "WS", dial_code: "+685", flag: "🇼🇸", label: "Samoa" },
      { code: "KN", dial_code: "+1", flag: "🇰🇳", label: "San Cristóbal y Nieves" },
      { code: "SM", dial_code: "+378", flag: "🇸🇲", label: "San Marino" },
      { code: "VC", dial_code: "+1", flag: "🇻🇨", label: "San Vicente y las Granadinas" },
      { code: "LC", dial_code: "+1", flag: "🇱🇨", label: "Santa Lucía" },
      { code: "ST", dial_code: "+239", flag: "🇸🇹", label: "Santo Tomé y Príncipe" },
      { code: "SN", dial_code: "+221", flag: "🇸🇳", label: "Senegal" },
      { code: "RS", dial_code: "+381", flag: "🇷🇸", label: "Serbia" },
      { code: "SC", dial_code: "+248", flag: "🇸🇨", label: "Seychelles" },
      { code: "SL", dial_code: "+232", flag: "🇸🇱", label: "Sierra Leona" },
      { code: "SG", dial_code: "+65", flag: "🇸🇬", label: "Singapur" },
      { code: "SY", dial_code: "+963", flag: "🇸🇾", label: "Siria" },
      { code: "SO", dial_code: "+252", flag: "🇸🇴", label: "Somalia" },
      { code: "LK", dial_code: "+94", flag: "🇱🇰", label: "Sri Lanka" },
      { code: "SD", dial_code: "+249", flag: "🇸🇩", label: "Sudán" },
      { code: "SS", dial_code: "+211", flag: "🇸🇸", label: "Sudán del Sur" },
      { code: "SE", dial_code: "+46", flag: "🇸🇪", label: "Suecia" },
      { code: "CH", dial_code: "+41", flag: "🇨🇭", label: "Suiza" },
      { code: "SR", dial_code: "+597", flag: "🇸🇷", label: "Surinam" },
      { code: "TH", dial_code: "+66", flag: "🇹🇭", label: "Tailandia" },
      { code: "TW", dial_code: "+886", flag: "🇹🇼", label: "Taiwán" },
      { code: "TZ", dial_code: "+255", flag: "🇹🇿", label: "Tanzania" },
      { code: "TJ", dial_code: "+992", flag: "🇹🇯", label: "Tayikistán" },
      { code: "TL", dial_code: "+670", flag: "🇹🇱", label: "Timor Oriental" },
      { code: "TG", dial_code: "+228", flag: "🇹🇬", label: "Togo" },
      { code: "TO", dial_code: "+676", flag: "🇹🇴", label: "Tonga" },
      { code: "TT", dial_code: "+1", flag: "🇹🇹", label: "Trinidad y Tobago" },
      { code: "TN", dial_code: "+216", flag: "🇹🇳", label: "Túnez" },
      { code: "TM", dial_code: "+993", flag: "🇹🇲", label: "Turkmenistán" },
      { code: "TR", dial_code: "+90", flag: "🇹🇷", label: "Turquía" },
      { code: "TV", dial_code: "+688", flag: "🇹🇻", label: "Tuvalu" },
      { code: "UA", dial_code: "+380", flag: "🇺🇦", label: "Ucrania" },
      { code: "UG", dial_code: "+256", flag: "🇺🇬", label: "Uganda" },
      { code: "UY", dial_code: "+598", flag: "🇺🇾", label: "Uruguay" },
      { code: "UZ", dial_code: "+998", flag: "🇺🇿", label: "Uzbekistán" },
      { code: "VU", dial_code: "+678", flag: "🇻🇺", label: "Vanuatu" },
      { code: "VE", dial_code: "+58", flag: "🇻🇪", label: "Venezuela" },
      { code: "VN", dial_code: "+84", flag: "🇻🇳", label: "Vietnam" },
      { code: "YE", dial_code: "+967", flag: "🇾🇪", label: "Yemen" },
      { code: "DJ", dial_code: "+253", flag: "🇩🇯", label: "Yibuti" },
      { code: "ZM", dial_code: "+260", flag: "🇿🇲", label: "Zambia" },
      { code: "ZW", dial_code: "+263", flag: "🇿🇼", label: "Zimbabue" },
    ],
  },
});

const emit = defineEmits(["update:modelValue"]);

const countrySelectOptions = computed(() =>
  props.countryOptions.map((option) => ({
    ...option,
    label: `${option.label} (${option.dial_code})`,
  }))
);

const selectedCountryCode = ref(props.countryOptions[0]?.code || "ES");
const localNumber = ref("");

const countrySelectId = computed(() => `${props.id}-country`);

function sanitizeNumber(value) {
  return String(value || "").replace(/\D/g, "");
}

function getSelectedCountry() {
  return (
    props.countryOptions.find((country) => country.code === selectedCountryCode.value) ||
    props.countryOptions[0] ||
    { code: "ES", dial_code: "+34" }
  );
}

function findCountryByPhone(phone) {
  const raw = String(phone || "").trim();
  const sorted = [...props.countryOptions].sort(
    (a, b) => String(b.dial_code || "").length - String(a.dial_code || "").length
  );
  return (
    sorted.find((option) => raw.startsWith(String(option.dial_code || ""))) ||
    props.countryOptions[0] ||
    { code: "ES", dial_code: "+34" }
  );
}

function parseModelValue(value) {
  const raw = String(value || "").trim();
  const selected = findCountryByPhone(raw);
  selectedCountryCode.value = selected.code || "ES";
  let number = raw;
  if (raw.startsWith(String(selected.dial_code || ""))) {
    number = raw.slice(String(selected.dial_code || "").length);
  }
  localNumber.value = sanitizeNumber(number);
}

watch(
  () => props.modelValue,
  (value) => {
    parseModelValue(value);
  },
  { immediate: true }
);

watch(
  () => [selectedCountryCode.value, localNumber.value],
  () => {
    const digits = sanitizeNumber(localNumber.value);
    const selected = getSelectedCountry();
    const fullPhone = digits ? `${selected.dial_code}${digits}` : "";
    if (fullPhone !== String(props.modelValue || "")) {
      emit("update:modelValue", fullPhone);
    }
  }
);

function onInput(event) {
  localNumber.value = sanitizeNumber(event?.target?.value);
}
</script>

<template>
  <div class="phone-input-grid">
    <div class="phone-country-field">
      <argon-select
        :id="countrySelectId"
        v-model="selectedCountryCode"
        name-label="label"
        name-value="code"
        :options="countrySelectOptions"
        :filterable="true"
        :clearable="false"
        :disabled="disabled"
        :error="error"
      />
    </div>
    <input
      :id="id"
      v-model="localNumber"
      type="tel"
      class="form-control"
      :class="{ 'is-invalid': error }"
      :maxlength="maxLength"
      :disabled="disabled"
      @input="onInput"
    />
  </div>
</template>

<style scoped>
.phone-input-grid {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 0.5rem;
  align-items: center;
}

.phone-input-grid :deep(.form-group) {
  margin-bottom: 0;
  margin-top: -2px;
}
</style>
